module.exports = __webpack_public_path__ + "img/hot.a8c03695.svg";